import { render } from "./SortLink.vue?vue&type=template&id=0f221009&bindings={\"value\":\"props\",\"currentSort\":\"props\",\"isActive\":\"options\",\"currentSortOrder\":\"options\",\"currentSortField\":\"options\",\"updateSort\":\"options\"}"
import script from "./SortLink.vue?vue&type=script&lang=js"
export * from "./SortLink.vue?vue&type=script&lang=js"
script.render = render

export default script